import {Component} from "@angular/core";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {CustomObjectTypeEntityModel} from "../custom-object-type-entity.model";
import {ProductLineCustomObjectTypeSearchModel} from "../product-line-custom-object-type-search.model";
import {CustomObjectTypeSearchPageComponent} from "./custom-object-type-search-page.component";

@Component({
    selector: "wbo-product-line-custom-object-type-search-page",
    templateUrl: "./custom-object-type-search-page.component.html",
    providers: [provideSearchModel(ProductLineCustomObjectTypeSearchModel), provideEntityModel(CustomObjectTypeEntityModel)]
})
export class ProductLineCustomObjectTypeSearchPageComponent extends CustomObjectTypeSearchPageComponent {
}
